import { IStringChildProps } from "Interfaces/Props/IStringChildProps";
import React from "react";

export class BrString extends React.Component<IStringChildProps> {
	render() {
		return this.props.children.split("\n").map(str => <>{str}<br/></>);
	}
}
